import Vue from 'vue';
import Component from 'vue-class-component';
import EdListSubstituteTeacherComponent from '@/tools/components/ed-substitute-teacher/ed-list-substitute-teacher/ed-list-substitute-teacher.component.vue';
import EdInviteSubstituteTeacherComponent from '@/tools/components/ed-substitute-teacher/ed-invite-substitute-teacher/ed-invite-substitute-teacher.component.vue';
import { INVITATION_TYPE } from '@/tools/values/substitute-teacher.values';
import KEYS from '@/values/keys';

@Component({
  name: 'substitute-teacher-admin',
  components: {
    EdListSubstituteTeacher: EdListSubstituteTeacherComponent,
    EdInviteSubstituteTeacher: EdInviteSubstituteTeacherComponent
  }
})
export default class SubstituteTeacherAdminView extends Vue {

  /* Data */
  public openInviteTeacher: boolean = false;
  public invitationData: any = {}

  public tab: any = '';
  public tabs = INVITATION_TYPE;

  public tabsOptionContent = [
    { id: 0, component: EdListSubstituteTeacherComponent, props: { tab: INVITATION_TYPE.GIVEN } },
    { id: 1, component: EdListSubstituteTeacherComponent, props: { tab: INVITATION_TYPE.RECEIVED } }
  ]

  /* Computed */
  get canInvite () {
    return !this.isStudent && !this.isOnlySubstituteTeacher && this.organizationId;
  }

  get isOnlySubstituteTeacher () {
    return this.$store.getters['AuthStore/isOnlySubstituteTeacher'];
  }

  get isStudent() {
    return this.$store.getters['AuthStore/isStudent'];
  }

  get organizationId() {
    return this.$store.state.ToolsStore.institutionInfo[0]?.organizationId;
  }

  get showReceivedInvitations() {
    return this.$route.query?.status === 'pending';
  }

  get tabsOptionHeader() {
    return [
      { id: 0, label: this.$i18n.t('tools.substituteTeacher.givenIntivations'), ariaControls: 'given-invitations' },
      { id: 1, label: this.$i18n.t('tools.substituteTeacher.receivedIntivations'), ariaControls: 'received-invitations' }
    ]
  }


  /* Methods */
  inviteTeacher() {
    this.invitationData = null;
    this.openInviteTeacher = !this.openInviteTeacher;
  }

  closeInviteTeacher() {
    this.openInviteTeacher = false;
    this.invitationData = null;
  }

  openEditInvitation(data: any = {}) {
    this.openInviteTeacher = true;
    this.invitationData = data;
  }

  /* Hooks */
  created() {
    this.$edEventBus.$on('closeInviteTeacher', this.closeInviteTeacher);
    this.$edEventBus.$on('openEditInvitation', this.openEditInvitation);
  }

  mounted() {
    this.tab = this.showReceivedInvitations ? 1 : 0;
  }

  beforeDestroy() {
    this.$edEventBus.$off('closeInviteTeacher');
    this.$edEventBus.$off('openEditInvitation');
  }

}
